import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { NdcSandboxToolGuidePage } from 'src/app/model/page/group/api-docs/ndc-sandbox-tool-guide-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-ndc-sandbox-tool-guide-page',
  templateUrl: './ndc-sandbox-tool-guide-page.component.html',
  styleUrls: ['./ndc-sandbox-tool-guide-page.component.scss']
})
export class NdcSandboxToolGuidePageComponent implements OnInit {
  ndcSandboxToolGuidePage: NdcSandboxToolGuidePage = {} as NdcSandboxToolGuidePage;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'sandbox-tool-guide') {
        this.ndcSandboxToolGuidePage.htmlTitle = title.htmlTitle;
      }
    });
    this.ndcSandboxToolGuidePage.sections = [];

    const query = { 'fields.title': 'NDC SandBox Tool Guide' };
    this.contentfulService.getPageContentResponse(query).then((NdcSandboxToolGuidePageEntries) => {
      this.mapBanner(NdcSandboxToolGuidePageEntries.includes.Entry);
      this.sharedDataService.addSharedData(this.ndcSandboxToolGuidePage.banner);
      this.mapSections(NdcSandboxToolGuidePageEntries.includes.Entry);
      this.mapPageInfo(NdcSandboxToolGuidePageEntries.items);
    });
  }

  private mapBanner(ndcSandboxToolGuidePageEntries: Entry<any>[]) {
    ndcSandboxToolGuidePageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];

    this.ndcSandboxToolGuidePage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url,
      video: videoDetails?.fields?.file?.url,
      lastUpdated: entry.fields['lastUpdated'] as string
    };
  }

  private mapSections(ndcSandboxToolGuidePageEntries: Entry<any>[]) {
    ndcSandboxToolGuidePageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });

    this.ndcSandboxToolGuidePage.sections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    let title: any = entry.fields['title'] as string;
    this.ndcSandboxToolGuidePage.sections.push({
      title: title.split('#').pop(),
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.ndcSandboxToolGuidePage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.ndcSandboxToolGuidePage.banner.url = entry.fields?.url;
      this.ndcSandboxToolGuidePage.banner.editorEmail = editorDetails?.pop();
      this.ndcSandboxToolGuidePage.banner.editorShortName = editorDetails?.pop();
      this.ndcSandboxToolGuidePage.banner.editorFullName = editorDetails?.pop();
      this.ndcSandboxToolGuidePage.htmlTitle = entry.fields.htmlTitle;
    });
  }
}
